import useMicroApp from './useMicroApp';

export default useMicroApp;
